<div class="layout-col full">
  @if (loadingBarMode$ | async; as loadingBarMode) {
    <div class="flex-none layout-col">
      <mat-progress-bar style="width: 100%" [mode]="loadingBarMode"></mat-progress-bar>
    </div>
  }

  @if (facilityUtilisation$ | async; as fUtil) {
    <elder-basic-pane-layout class="flex">
      <elder-pane class="flex-none layout-col" style="width: 15vw">
        <elder-pane-header>
          <elder-pane-title>{{ 'utilization.facilityUtilization' | translate }}</elder-pane-title>
          <elder-pane-actions>
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="assignProcessPlans()">
                {{ 'commands.assign-missing-process-plans' | translate }}
              </button>
              <button mat-menu-item (click)="assignProdRoutes()">
                {{ 'commands.assign-missing-prod-routes' | translate }}
                @if (this.liveMode === MexusViewMode.LIVE) {
                  ({{ 'utilization.viewMode.LIVE' | translate }})
                }
              </button>
              <button mat-menu-item (click)="calculateUtilisation()">
                {{ 'commands.calculate-utilisation-again' | translate }}
              </button>
            </mat-menu>
          </elder-pane-actions>
        </elder-pane-header>
        <elder-pane-content class="layout-row place-center-center">
          @if (fUtil; as facilityUtilisation) {
            <div class="flex layout-col gap-lg">
              <!-- Date -->
              <!-- todo: switch locale when English is selected-->
              <span class="text-body-medium">{{
                (facilityUtilisation.scheduleInterval | isoIntervalParse)?.start?.toJSON()
                  | date: 'fullDate'
              }}</span>
              <!-- Manufacturing progress -->
              <div class="layout-col gap-sm">
                <h4 class="text-title-medium">{{ 'utilization.progress' | translate }}</h4>
                <app-utilisation-progress-bar [facilityUtilisation]="facilityUtilisation">
                </app-utilisation-progress-bar>
              </div>
              <!-- Total item summary -->
              <div class="layout-col gap-sm">
                <h4 class="text-title-medium">Total</h4>
                <div class="layout-col">
                  <div class="flex layout-row place-between-center text-body-medium">
                    <span>{{ 'context.items' | translate }}: </span>
                    <span>{{ facilityUtilisation.totalItems.itemCount }}</span>
                  </div>
                  <div class="flex layout-row place-between-center text-body-medium">
                    <span>{{ 'context.pieces' | translate }}: </span>
                    <span>{{ facilityUtilisation.totalItems.piecesCount }}</span>
                  </div>
                  <div class="flex layout-row place-between-center text-body-medium">
                    <span>{{ 'positions.weight' | translate }}: </span>
                    <span>{{ facilityUtilisation.totalItems.totalWeight | elderQuantity }}</span>
                  </div>
                </div>
              </div>
              <!-- Unassigned item summary -->
              @if (facilityUtilisation.unassigned.itemCount > 0) {
                <div class="layout-col gap-sm">
                  <h4 class="text-title-medium">Unassigned</h4>
                  <div class="layout-col">
                    <div class="flex layout-row place-between-center">
                      <span>{{ 'context.items' | translate }}: </span>
                      <span>{{ facilityUtilisation.unassigned.itemCount }}</span>
                    </div>
                    <div class="flex layout-row place-between-center">
                      <span>{{ 'context.pieces' | translate }}: </span>
                      <span>{{ facilityUtilisation.unassigned.piecesCount }}</span>
                    </div>
                    <div class="flex layout-row place-between-center">
                      <span>{{ 'positions.weight' | translate }}: </span>
                      <span>{{ facilityUtilisation.unassigned.totalWeight | elderQuantity }}</span>
                    </div>
                  </div>
                </div>
              }
              <!-- Trigger optimisation -->
              <button mat-flat-button color="primary" (click)="optimiseProdRoutes()">
                <mat-icon>show_chart</mat-icon>
                {{ 'utilization.optimize' | translate }}
              </button>
              @if (utilizationTuningEnabled()) {
                <button mat-flat-button color="primary" (click)="evaluateProdRoute()">
                  <mat-icon>online_prediction</mat-icon>
                  {{ 'Auslastung evaluieren' }}
                </button>
              }
              @if (utilizationTuningEnabled()) {
                <button mat-flat-button color="primary" (click)="abortFullDay()">
                  <mat-icon>delete</mat-icon>
                  {{ 'Produktion zurücksetzen' }}
                </button>
              }
              @if (utilizationTuningEnabled()) {
                <button mat-flat-button color="primary" (click)="resetFullDay()">
                  <mat-icon>restart_alt</mat-icon>
                  {{ 'Zuweisungen zurücksetzen' }}
                </button>
              }
            </div>
          }
        </elder-pane-content>
      </elder-pane>
      <elder-pane>
        <app-work-center-utilisation-viewer
          class="flex"
          [workCenterUtilisations]="fUtil.workCenterUtilisations"
        >
        </app-work-center-utilisation-viewer>
      </elder-pane>
    </elder-basic-pane-layout>
  }
</div>
